import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo-undesirable-no-1_00.jpg";

const data: ReplicaItemType = {
  id: "the-quibbler-v1-undesirable-no-1-grade-b",
  name: "The Quibbler v1 - Undesirable No. 1 (Grade B)",
  nameFormatted: {
    primary: "Grade B",
    secondary: "The Quibbler v1",
    tertiary: "Undesirable No. 1",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
